import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import { BrowserRouter } from 'react-router-dom'
import { appUrl } from './config'

console.log(`AppUrl:${appUrl}`)

ReactDOM.render(
  <BrowserRouter basename={'/covid20'}>
    <App />
  </BrowserRouter>,
  document.getElementById('root')
)
